import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full w-lg md:w-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", { class: "grid grid-cols-[minmax(110px,1fr),minmax(110px,1fr),minmax(50px,80px),minmax(110px,1fr),20px] md:grid-cols-[minmax(110px,1fr),minmax(110px,1fr),60px,minmax(100px,1fr),70px] lg:grid-cols-[minmax(160px,200px),210px,150px,150px,1fr] gap-x-2 md:gap-2 t-12m lg:t-14m text-black border-wrh-gray-light border-b-1 py-4 md:mx-6 mx-4 md:px-0 md:mr-8" }, [
  /*#__PURE__*/_createElementVNode("li", null, " File Name"),
  /*#__PURE__*/_createElementVNode("li", null, "Uploaded On"),
  /*#__PURE__*/_createElementVNode("li", null, "Type"),
  /*#__PURE__*/_createElementVNode("li", null, "Document Level"),
  /*#__PURE__*/_createElementVNode("li", { class: "hidden md:block" }, "Actions")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "md:h-[calc(100vh-323px)] mdlg:h-[calc(100vh-285px)] lg:h-[calc(100vh-235px)] md:wrh-scroll"
}

import {
  toRefs, ref, watch, onUnmounted,
} from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { Document } from '@/models';
import DocumentsListItem from './DocumentsListItem.vue';
import DocumentSkeleton from '@/components/skeleton/DocumentSkeleton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    documents: { type: null, required: true },
    totalDocuments: { type: Number, required: true },
    showDocumentSkeleton: { type: Boolean, required: true }
  },
  emits: ['download', 'viewFile', 'fetchNewRecords'],
  setup(__props: any, { emit }) {

const props = __props as {
  documents: any,
  totalDocuments: number,
  showDocumentSkeleton: boolean,
}




const { documents, totalDocuments, showDocumentSkeleton } = toRefs(props);
const scrollBottom = ref(null);
const targetIsVisible = ref(false);

const { stop } = useIntersectionObserver(
  scrollBottom,
  ([{ isIntersecting }], observerElement) => {
    targetIsVisible.value = isIntersecting && totalDocuments.value > 0;
  },
);

const fetchMoreRecords = () => {
  if (totalDocuments.value > documents.value.length) {
    emit('fetchNewRecords');
  }
};

watch(targetIsVisible, (value) => {
  if (value) {
    fetchMoreRecords();
  }
});

const downloadFile = (document:Document) => {
  emit('download', document);
};

const viewFile = (document:Document) => {
  if (document.fileExtension === 'pdf') {
    emit('viewFile', document);
  } else {
    emit('download', document);
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(showDocumentSkeleton))
      ? (_openBlock(), _createBlock(DocumentSkeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documents), (document, index) => {
            return (_openBlock(), _createBlock(DocumentsListItem, {
              document: document,
              onDownload: ($event: any) => (downloadFile(document)),
              onView: ($event: any) => (viewFile(document)),
              key: index
            }, null, 8, ["document", "onDownload", "onView"]))
          }), 128)),
          _createElementVNode("li", {
            ref: (_value, _refs) => {
              _refs['scrollBottom'] = _value
              scrollBottom.value = _value
            }
          }, null, 512)
        ]))
  ]))
}
}

})